define((require) => {
    "use strict";

    const InfiniteScrollingCollectionView = require("ui/common/InfiniteScrollingCollectionView");
    const NoResultsItemView               = require("zbone/NoResultsItemView");
    const ContentItemView                 = require("ui/dashboard/ContentItemView");

    /**
     * A <tt>InfiniteScrollingCollectionView</tt> subclass for displaying (and lazy loading) publishables (experiences and/or groups).
     *
     * @cfg {PublishableCollection} collection The <tt>PublishableCollection</tt> to render.
     *
     * @see  PublishableCollection
     * @see  InfiniteScrollingCollectionView
     *
     * @class PublishableCollectionView
     */
    return InfiniteScrollingCollectionView.extend("PublishableCollectionView", {

        itemView: ContentItemView,

        onEmpty() {
            return new NoResultsItemView({type: "Contents"});
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/publish/PublishableCollectionView.js